<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="名称" prop="compayName">
        <a-input v-model="form.compayName" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="主图" prop="logo">
        <file-upload type="image" :defaultList="form.logoArr" :count="1" :imgSize="'96*96'" @input="getImg($event, 'logo')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="视频地址" prop="video">
        <file-upload type="file" :defaultList="form.videoArr" :count="1" @input="getImg($event, 'video')"></file-upload>
        <video
          v-if="form.video"
          style="width: 180px; height: 120px"
          class="avatar video-avatar"
          controls="controls"
          :src="form.videoArr[0].url"
        />
      </a-form-model-item>
      <a-form-model-item label="相册" prop="photoAlbum">
        <file-upload
          type="image"
          :defaultList="form.photoArr"
          :count="6"
          @input="getImg($event, 'photoAlbum')"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="介绍" prop="introduce">
        <a-input type="textarea" v-model="form.introduce" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompany, addCompany, updateCompany } from '@/api/company/company'
import { guid } from '@/utils/ruoyi'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    Editor,
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        compayName: null,
        logoCount: 1,
        logoArr: [],
        logo: null,
        videoCount: 1,
        videoArr: [],
        video: null,
        introduce: null,
        photoArr: [],
        photoCount: 6,
        photoAlbum: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        compayName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        logo: [{ required: true, message: '主图不能为空', trigger: 'blur' }],
        video: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
        photoAlbum: [{ required: true, message: '相册不能为空', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        compayName: null,
        logoCount: 1,
        logoArr: [],
        logo: null,
        videoCount: 1,
        videoArr: [],
        video: null,
        introduce: null,
        photoArr: [],
        photoCount: 6,
        photoAlbum: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompany({ id: id }).then((response) => {
        console.log(response.data, '返回')
        this.form.logo = response.data.logo
        this.form.video = response.data.video
        this.form.photoAlbum = response.data.photoAlbum
        this.form.introduce = response.data.introduce
        this.form.compayName = response.data.compayName
        this.form.id = response.data.id
        let that = this
        this.form.logoArr = []
        this.form.logoArr.push({
          uid: guid(8, 10),
          name: that.form.logo,
          status: 'done',
          halfUrl: that.form.logo,
          url: that.form.logo,
          path: that.form.logo,
        })
        this.form.videoArr = []
        this.form.videoArr.push({
          uid: guid(8, 10),
          name: that.form.video,
          status: 'done',
          halfUrl: that.form.video,
          url: that.form.video,
          path: that.form.video,
        })
        this.form.photoArr = []
        if (this.form.photoAlbum) {
          this.form.photoAlbum.split(',').forEach((item) => {
            that.form.photoArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item,
            })
          })
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompany(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addCompany(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
